/**
 * APIMessage component - displays message to user related to API calls - if saves are successful, or if there were errors
 * 
 * @param {string} message
 * @param {boolean} isError determines how the message will be styled
 * @param {string} className can add more classes if needed
 * @returns {JSX.Element}
 * 
 * @category Components - UI
 */
export const APIMessage = ({message, isError = false, className = null}) => {
    if(!message || message.length === 0) return null

    const classNames = isError ? `text-red-500 my-4 ${className}` : `text-green-500 my-4 ${className}`
    
    const Icon = () => {
        return isError ? <i className="fa-solid fa-circle-exclamation text-red-500 mr-2"></i> : <i className="fa-solid fa-circle-check text-green-500 mr-2"></i>
    }

    return(
        <p className={classNames}><Icon/>{message}</p>
    )
    
}